import clsx from "clsx";
import React from "react";
import styles from "./STFooter.module.css";
import Image from "next/image";
import { LogoBlack } from "@/assets/images";
import { footerLinks } from "@/const/data";
import Link from "next/link";
import { Icons } from "@/const/icons";
import { footerLogo } from "../../assets/images";

export const STFooter = () => {
  return (
    <footer
      className={clsx(
        styles.footer,
        "space-md-py bg-blue text-clr-white position-relative",
      )}
    >
      <div className="container">
        <Link
          href={"/"}
          className={clsx(
            styles.logo,
            "d-inline-flex align-items-center gap-xs",
          )}
        >
          <Image
            src={footerLogo}
            alt="Sustanix Logo"
            className={clsx(styles.logoImg, "w-100 h-auto")}
          />
          {/* <h3 className="mb-0 text-white">Sustanix</h3> */}
        </Link>
        <div className="d-flex flex-column flex-lg-row align-items-xl-end justify-content-between gap-md space-md-mb">
          <h2 className={clsx(styles.title, "mb-0")}>
            Your material problems,
            <span className="d-block">and our technology,</span>
            <span className="text-clr-white d-block"> it’s a chemistry!</span>
          </h2>

          <div
            className={clsx(
              styles.rightLinkWrap,
              "d-flex align-items-start w-100 flex-column flex-sm-row",
            )}
          >
            <div className={clsx(styles.linksWrapper, "d-grid w-100")}>
              {footerLinks.map((column, index) => (
                <ul key={index} className={styles.linkList}>
                  {column.links.map((link, idx) => (
                    <li
                      key={idx}
                      className={clsx(styles.linkItem, "position-relative")}
                    >
                      <Link
                        className={clsx(
                          "h6 mb-0 d-flex align-items-center justify-content-between gap-xs",
                          styles.link,
                        )}
                        href={link.href}
                      >
                        {link.label}
                        {link.children && (
                          <span
                            className={clsx(
                              styles.dropdownIcon,
                              "d-flex cursor-pointer transition-smooth",
                            )}
                          >
                            {Icons.arrowDown}
                          </span>
                        )}
                      </Link>

                      {link.children && (
                        <ul className={styles.dropdown}>
                          {link.children.map((child, i) => (
                            <li key={i}>
                              <Link
                                href={child.href}
                                className={clsx(styles.dropdownLink, "sm")}
                              >
                                {child.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              ))}
            </div>
            <Link
              href={
                "https://www.linkedin.com/company/sustanix/?viewAsMember=true"
              }
              target="_blank"
              className={clsx(
                styles.socialLink,
                "d-inline-flex align-items-center gap-2 text-clr-white",
              )}
            >
              {Icons.linkedinIcon}
              Linkedin
            </Link>
          </div>
        </div>
        <div className="d-flex align-items-center gap-xs flex-wrap flex-sm-nowrap justify-content-between">
          <p className={clsx("mb-0 sm text-uppercase", styles.copyright)}>
            © Sustanix 2026. All rights reserved.
          </p>
        </div>
        <button
          aria-label="Scroll to top"
          className={clsx(
            styles.scrollTop,
            "posistion-absolute rounded-circle d-flex align-items-center justify-content-center text-clr-black border-0 bg-clr-white transition-smooth",
          )}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          {Icons.arrowUp}
        </button>
      </div>
    </footer>
  );
};
